/**
 * Die Einträge des Haus-Filters (Spec 46a, „Haus-Filter") — eine Quelle für
 * beide Formen: Sidebar-Einträge ab 768 px und Chipzeile darunter. Die Häuser
 * und ihre Zähler kommen vom Server (`GET /energy/meters` → `houses`); der
 * Client zählt nichts selbst nach, nur „Alle Zähler" ist die Summe der
 * gelieferten `meter_count`.
 */

import type { MeterHouse } from '@/features/energy/api'

export interface HouseFilterEntry {
  /** `undefined` ist „Alle". */
  readonly houseId: string | undefined
  readonly testId: string
  readonly label: string
  readonly count: number
  readonly isActive: boolean
}

const ALL_HOUSES_TEST_ID = 'energy-house-filter-all'

/** Ein gewähltes Haus, das in `houses` nicht (mehr) vorkommt, fällt auf „Alle"
 * zurück (letzter Zähler archiviert, geteilter Link auf fremdes Haus). */
export function resolveHouse(houses: readonly MeterHouse[], selected: string | undefined): string | undefined {
  return selected !== undefined && houses.some((house) => house.id === selected) ? selected : undefined
}

export function houseFilterEntries(
  houses: readonly MeterHouse[],
  selected: string | undefined,
  allLabel: string,
): HouseFilterEntry[] {
  const active = resolveHouse(houses, selected)
  return [
    {
      houseId: undefined,
      testId: ALL_HOUSES_TEST_ID,
      label: allLabel,
      count: houses.reduce((sum, house) => sum + house.meter_count, 0),
      isActive: active === undefined,
    },
    ...houses.map((house) => ({
      houseId: house.id,
      testId: `energy-house-filter-${house.id}`,
      label: house.label,
      count: house.meter_count,
      isActive: active === house.id,
    })),
  ]
}
